// extracted by mini-css-extract-plugin
export default {"clear":"reset_clear_b9xre","clearfix":"reset_clearfix_lrufM"};